import { render, staticRenderFns } from "./EditSynthetical.vue?vue&type=template&id=550017e5&scoped=true&"
import script from "./EditSynthetical.vue?vue&type=script&lang=js&"
export * from "./EditSynthetical.vue?vue&type=script&lang=js&"
import style0 from "./EditSynthetical.vue?vue&type=style&index=0&id=550017e5&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550017e5",
  null
  
)

export default component.exports